import {Injectable} from '@angular/core';
import {
  HarbourDuesContainerClass,
  HarbourDuesContainerHandlingCount
} from "@portbase/bezoekschip-service-typescriptmodels";
import {formatContainerClass, HARBOUR_DUES_CONTAINER_CLASSES} from "../harbour-dues-container-class";

export interface ContainerHandlingColumnTotals {
  full: number;
  empty: number;
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class HarbourDuesContainerHandlingService {

  containerTypes(): HarbourDuesContainerClass[] {
    return [...HARBOUR_DUES_CONTAINER_CLASSES];
  }

  formatContainerType(type: HarbourDuesContainerClass): string {
    return formatContainerClass(type);
  }

  rowTotal(row?: HarbourDuesContainerHandlingCount): number {
    return (row?.full || 0) + (row?.empty || 0);
  }

  columnTotals(rows: HarbourDuesContainerHandlingCount[] = []): ContainerHandlingColumnTotals {
    let full = 0;
    let empty = 0;
    for (const row of rows) {
      full += row.full || 0;
      empty += row.empty || 0;
    }
    return {full, empty, total: full + empty};
  }
}
